import { combineReducers } from "redux"

// Front
import Layout from "./layout/reducer"

// Authentication
import Login from "./auth/login/reducer"
import Account from "./auth/register/reducer"
import ForgetPassword from "./auth/forgetpwd/reducer"
import Profile from "./auth/profile/reducer"
import Dashboard from "./dashboard/reducer";
import Bookings from "./bookings/reducer";
import Drivers from "./drivers/reducer";
import Customers from "./customers/reducer";
import Materials from "./materials/reducer";
import Refferals from "./refferals/reducer";
import ContactUs from "./contact-us/reducer";
import Discounts from "./discounts/reducer";
import Promotions from "./promotions/reducer";
import Faqs from "./faqs/reducer";
import PromoCodes from "./promo-codes/reducer";
import Vehicles from "./vehicles/reducer";
import vehiclesCategories from "./vehicles-categories/reducer";
import Garages from "./garages/reducer";
import vehicleBodyTypes from "./vehicles-bodytypes/reducer";
import driversDocumentsTypes from "./drivers-documents-types/reducer";
import driversDocuments from "./drivers-documents/reducer";
import vehiclesDocumentsTypes from "./vehicles-documents-types/reducer";
import vehiclesDocuments from "./vehicles-documents/reducer";
import aneesVouchers from "./anees-vouchers/reducer";

//Calendar
import calendar from "./calendar/reducer"

const rootReducer = combineReducers({
  // public
  Layout,
  Login,
  Account,
  ForgetPassword,
  Profile,
  calendar,
  Dashboard,
  Bookings,
  Drivers,
  Customers,
  Materials,
  ContactUs,
  Refferals,
  Discounts,
  Promotions,
  Garages,
  vehicleBodyTypes,
  Faqs,
  PromoCodes,
  Vehicles,
  vehiclesCategories,
  driversDocumentsTypes,
  driversDocuments,
  vehiclesDocumentsTypes,
  vehiclesDocuments,
  aneesVouchers
})

export default rootReducer
